<template>
  <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h3>编辑门店</h3>
        <button @click="handleClose" class="close-btn">&times;</button>
      </div>
      
      <div class="modal-body">
        <form @submit.prevent="handleSubmit" class="store-form">
          <div class="form-group">
            <label for="storeName" class="required">门店名称</label>
            <input
              id="storeName"
              v-model="formData.storeName"
              type="text"
              placeholder="请输入门店名称"
              class="form-input"
              :class="{ 'error': errors.storeName }"
              required
            />
            <span v-if="errors.storeName" class="error-message">{{ errors.storeName }}</span>
          </div>
          
          <div class="form-group">
            <label for="address" class="required">门店地址</label>
            <input
              id="address"
              v-model="formData.address"
              type="text"
              placeholder="请输入门店地址"
              class="form-input"
              :class="{ 'error': errors.address }"
              required
            />
            <span v-if="errors.address" class="error-message">{{ errors.address }}</span>
          </div>
          
          <div class="form-group">
            <label for="status" class="required">状态</label>
            <select
              id="status"
              v-model="formData.status"
              class="form-select"
              :class="{ 'error': errors.status }"
              required
            >
              <option value="">请选择状态</option>
              <option :value="1">启用</option>
              <option :value="0">禁用</option>
            </select>
            <span v-if="errors.status" class="error-message">{{ errors.status }}</span>
          </div>
          
          <div class="form-group">
            <label for="description">门店描述</label>
            <textarea
              id="description"
              v-model="formData.description"
              placeholder="请输入门店描述（可选）"
              class="form-textarea"
              rows="3"
            ></textarea>
          </div>
          
          <div class="form-group">
            <label for="gongGao">客户端公告</label>
            <textarea
              id="gongGao"
              v-model="formData.gongGao"
              placeholder="请输入客户端公告（最多100字）"
              class="form-textarea"
              rows="3"
              maxlength="100"
            ></textarea>
            <div class="char-count">{{ formData.gongGao ? formData.gongGao.length : 0 }}/100</div>
          </div>
          
          <div class="form-group">
            <label for="rechargeDiscountInformation">会员充值优惠公告</label>
            <textarea
              id="rechargeDiscountInformation"
              v-model="formData.rechargeDiscountInformation"
              placeholder="请输入会员充值优惠公告（最多100字）"
              class="form-textarea"
              rows="3"
              maxlength="100"
            ></textarea>
            <div class="char-count">{{ formData.rechargeDiscountInformation ? formData.rechargeDiscountInformation.length : 0 }}/100</div>
          </div>

          <div class="form-group">
            <label for="playNotice">游玩须知</label>
            <textarea
              id="playNotice"
              v-model="formData.playNotice"
              placeholder="请输入游玩须知（最多100字）"
              class="form-textarea"
              rows="3"
              maxlength="100"
            ></textarea>
            <div class="char-count">{{ formData.playNotice ? formData.playNotice.length : 0 }}/100</div>
          </div>

          <div class="form-group">
            <label for="priceInfo">价目表</label>
            <textarea
              id="priceInfo"
              v-model="formData.priceInfo"
              placeholder="请输入价目表，支持多行，如：&#10;30分钟：35元&#10;1小时：60元&#10;1.5小时：80元"
              class="form-textarea"
              rows="4"
              maxlength="500"
            ></textarea>
            <div class="char-count">{{ formData.priceInfo ? formData.priceInfo.length : 0 }}/500</div>
          </div>
          
          <div class="form-group">
            <label for="keFuPhone">客服热线号码</label>
            <input
              id="keFuPhone"
              v-model="formData.keFuPhone"
              type="text"
              placeholder="请输入客服热线号码"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label for="storeAdmins" class="required">门店管理员</label>
            <div class="multi-select-container">
              <div class="multi-select-display" :class="{ 'error': errors.storeAdmins }" @click="toggleAdminDropdown">
                <span v-if="selectedAdmins.length === 0" class="placeholder">请选择门店管理员</span>
                <span v-else class="selected-items">
                  {{ selectedAdmins.map(admin => formatAdminDisplayName(admin)).join(', ') }}
                </span>
                <span class="dropdown-arrow" :class="{ 'open': adminDropdownOpen }">▼</span>
              </div>
              <div v-if="adminDropdownOpen" class="multi-select-dropdown">
                <div class="dropdown-search">
                  <input
                    v-model="adminSearchKeyword"
                    type="text"
                    placeholder="搜索管理员..."
                    class="search-input"
                    @click.stop
                  />
                </div>
                <div class="dropdown-options">
                  <div
                    v-for="admin in filteredAdmins"
                    :key="admin.id"
                    class="dropdown-option"
                    :class="{ 'selected': isAdminSelected(admin.id) }"
                    @click="toggleAdminSelection(admin)"
                  >
                    <input
                      type="checkbox"
                      :checked="isAdminSelected(admin.id)"
                      @click.stop
                    />
                    <span>{{ formatAdminOptionLabel(admin) }}</span>
                  </div>
                  <div v-if="filteredAdmins.length === 0" class="no-options">
                    暂无数据
                  </div>
                </div>
              </div>
            </div>
            <span v-if="errors.storeAdmins" class="error-message">{{ errors.storeAdmins }}</span>
          </div>
        </form>
      </div>
      
      <div class="modal-footer">
        <button @click="handleClose" class="cancel-btn">取消</button>
        <button @click="handleSubmit" class="submit-btn" :disabled="loading">
          {{ loading ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'EditStoreModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    storeData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'success'],
  data() {
    return {
      loading: false,
      formData: {
        id: null,
        storeCode: '',
        storeName: '',
        address: '',
        description: '',
        status: null,
        gongGao: '',
        rechargeDiscountInformation: '',
        playNotice: '',
        priceInfo: '',
        keFuPhone: ''
      },
      errors: {},
      adminList: [],
      selectedAdmins: [],
      adminDropdownOpen: false,
      adminSearchKeyword: ''
    }
  },
  computed: {
    filteredAdmins() {
      // 如果有搜索关键词，进行过滤
      if (this.adminSearchKeyword.trim()) {
        const keyword = this.adminSearchKeyword.toLowerCase()
        return this.adminList.filter(admin => {
          const nickname = (admin.nickname || '').toLowerCase()
          const username = (admin.username || '').toLowerCase()
          const phone = (admin.phone || '').toLowerCase()
          const realName = (admin.realName || '').toLowerCase()
          return nickname.includes(keyword) || username.includes(keyword) || phone.includes(keyword) || realName.includes(keyword)
        })
      }
      // 没有搜索关键词时，返回所有管理员
      return this.adminList
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadAdminList()
        if (this.storeData) {
          this.initFormData()
        }
        // 添加点击外部关闭下拉框的监听
        this.$nextTick(() => {
          document.addEventListener('click', this.handleDocumentClick)
        })
      } else {
        // 移除监听
        document.removeEventListener('click', this.handleDocumentClick)
      }
    },
    storeData: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.initFormData()
        }
      },
      deep: true
    }
  },
  methods: {
    initFormData() {
      this.formData = {
        id: this.storeData.id || null,
        storeCode: this.storeData.storeCode || '',
        storeName: this.storeData.storeName || '',
        address: this.storeData.address || '',
        description: this.storeData.description || '',
        status: this.storeData.status !== undefined ? Number(this.storeData.status) : null,
        gongGao: this.storeData.gongGao || '',
        rechargeDiscountInformation: this.storeData.rechargeDiscountInformation || '',
        playNotice: this.storeData.playNotice || '',
        priceInfo: this.storeData.priceInfo || '',
        keFuPhone: this.storeData.keFuPhone || ''
      }
      
      // 初始化门店管理员选择 - 直接使用storeAdminVOS中的数据
      if (this.storeData.storeAdminVOS && Array.isArray(this.storeData.storeAdminVOS)) {
        // 直接使用storeAdminVOS中的管理员对象，不需要查找ID
        this.selectedAdmins = [...this.storeData.storeAdminVOS]
      } else {
        this.selectedAdmins = []
      }
      
      this.errors = {}
      this.loading = false
      this.adminSearchKeyword = ''
    },
    
    validateForm() {
      this.errors = {}
      let isValid = true
      
      if (!this.formData.storeName.trim()) {
        this.errors.storeName = '请输入门店名称'
        isValid = false
      }
      
      if (!this.formData.address.trim()) {
        this.errors.address = '请输入门店地址'
        isValid = false
      }
      
      if (this.formData.status === null || this.formData.status === '') {
        this.errors.status = '请选择状态'
        isValid = false
      }
      
      if (this.selectedAdmins.length === 0) {
        this.errors.storeAdmins = '请选择门店管理员'
        isValid = false
      }
      
      return isValid
    },
    
    async handleSubmit() {
      if (!this.validateForm()) {
        return
      }
      
      this.loading = true
      
      try {
        const response = await request.post('/api/stores/updateStore', {
          id: this.formData.id,
          storeCode: this.formData.storeCode,
          storeName: this.formData.storeName.trim(),
          address: this.formData.address.trim(),
          description: this.formData.description.trim(),
          gongGao: this.formData.gongGao.trim() || null,
          rechargeDiscountInformation: this.formData.rechargeDiscountInformation.trim() || null,
          playNotice: this.formData.playNotice.trim() || null,
          priceInfo: this.formData.priceInfo.trim() || null,
          keFuPhone: this.formData.keFuPhone.trim() || null,
          status: Number(this.formData.status),
          adminIdList: this.selectedAdmins.map(admin => admin.adminId || admin.id)
        })
        
        if (response.data.success && response.data.code === 200) {
          this.$emit('success', response.data.data)
          this.handleClose()
        } else {
          throw new Error(response.data.message || '更新门店失败')
        }
        
      } catch (error) {
        console.error('更新门店失败:', error)
        let errorMessage = '更新门店失败'
        
        if (error.response) {
          errorMessage = error.response.data.message || `服务器错误: ${error.response.status}`
        } else if (error.request) {
          errorMessage = '网络连接失败，请检查网络或服务器状态'
        } else {
          errorMessage = error.message || '更新门店失败，请重试'
        }
        
        alert(errorMessage)
      } finally {
        this.loading = false
      }
    },
    
    handleClose() {
      this.$emit('close')
    },
    
    handleOverlayClick() {
      if (!this.loading) {
        this.handleClose()
      }
    },
    
    async loadAdminList() {
      try {
        const response = await request.get('/api/users/getUsers', {
          params: {
            page: 0,
            size: 5000,
            role: 'STORE_ADMIN'
          }
        })

        if (response.data.success && response.data.code === 200) {
          this.adminList = response.data.data.content || []
          console.log('管理员列表加载成功，数量:', this.adminList.length)
          if (this.adminList.length > 0) {
            console.log('第一个用户数据:', this.adminList[0])
          }
        } else {
          throw new Error(response.data.message || '获取管理员列表失败')
        }
      } catch (error) {
        console.error('获取管理员列表失败:', error)
        this.adminList = []
      }
    },
    
    toggleAdminDropdown() {
      this.adminDropdownOpen = !this.adminDropdownOpen
      if (this.adminDropdownOpen) {
        this.adminSearchKeyword = ''
      }
    },
    
    toggleAdminSelection(admin) {
      // 支持两种数据结构：storeAdminVOS中的adminId和adminList中的id
      const adminId = admin.id || admin
      const index = this.selectedAdmins.findIndex(selected => 
        (selected.adminId || selected.id) === adminId
      )
      
      if (index > -1) {
        this.selectedAdmins.splice(index, 1)
      } else {
        // 如果admin是对象，直接使用；如果是ID，则从filteredAdmins中找到完整的admin对象
        if (typeof admin === 'object' && admin.id) {
          // 转换为storeAdminVOS格式以保持一致性
          this.selectedAdmins.push({
            adminId: admin.id,
            adminName: admin.nickname || admin.realName || admin.username,
            nickname: admin.nickname,
            username: admin.username,
            phone: admin.phone,
            realName: admin.realName
          })
        } else {
          const adminObj = this.filteredAdmins.find(a => a.id === adminId)
          if (adminObj) {
            // 转换为storeAdminVOS格式以保持一致性
            this.selectedAdmins.push({
              adminId: adminObj.id,
              adminName: adminObj.nickname || adminObj.realName || adminObj.username,
              nickname: adminObj.nickname,
              username: adminObj.username,
              phone: adminObj.phone,
              realName: adminObj.realName
            })
          }
        }
      }
    },
    
    isAdminSelected(adminId) {
      return this.selectedAdmins.some(selected => {
        // 支持两种数据结构：storeAdminVOS中的adminId和adminList中的id
        return (selected.adminId || selected.id) === adminId
      })
    },
    
    getAdminName(adminId) {
      const admin = this.adminList.find(admin => admin.id === adminId)
      return admin ? admin.username : ''
    },

    formatAdminDisplayName(admin) {
      return admin.nickname || admin.adminName || admin.realName || admin.username || `ID:${admin.adminId || admin.id}`
    },

    formatAdminOptionLabel(admin) {
      const name = this.formatAdminDisplayName(admin)
      const extras = [admin.username, admin.phone].filter(value => value && value !== name)
      return extras.length > 0 ? `${name} (${extras.join(' / ')})` : name
    },
    
    handleDocumentClick(event) {
      // 如果点击的不是多选下拉框，则关闭下拉框
      if (!event.target.closest('.multi-select-container')) {
        this.adminDropdownOpen = false
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #666;
}

.modal-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.store-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group label.required::after {
  content: ' *';
  color: #ff4d4f;
}

.form-input, .form-textarea, .form-select {
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  font-family: inherit;
}

.form-input:focus, .form-textarea:focus, .form-select:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-input.error, .form-textarea.error, .form-select.error {
  border-color: #ff4d4f;
}

.form-select {
  background-color: white;
  cursor: pointer;
}

.form-select option {
  padding: 8px;
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}

.char-count {
  color: #999;
  font-size: 12px;
  text-align: right;
  margin-top: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.cancel-btn, .submit-btn {
  padding: 8px 20px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.cancel-btn {
  background: white;
  color: #666;
}

.cancel-btn:hover {
  background: #f5f5f5;
  border-color: #40a9ff;
}

.submit-btn {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
}

.submit-btn:hover:not(:disabled) {
  background: #40a9ff;
  border-color: #40a9ff;
}

.submit-btn:disabled {
  background: #d9d9d9;
  border-color: #d9d9d9;
  cursor: not-allowed;
  color: #999;
}

/* 多选下拉框样式 */
.multi-select-container {
  position: relative;
  width: 100%;
}

.multi-select-display {
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 20px;
  transition: border-color 0.3s ease;
}

.multi-select-display:hover {
  border-color: #40a9ff;
}

.multi-select-display:focus-within {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.multi-select-display.error {
  border-color: #ff4d4f;
}

.placeholder {
  color: #999;
}

.selected-items {
  color: #333;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-arrow {
  color: #999;
  font-size: 12px;
  transition: transform 0.3s ease;
  margin-left: 8px;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.multi-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 200px;
  overflow: hidden;
}

.dropdown-search {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.dropdown-search .search-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 12px;
}

.dropdown-search .search-input:focus {
  outline: none;
  border-color: #1890ff;
}

.dropdown-options {
  max-height: 150px;
  overflow-y: auto;
}

.dropdown-option {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
}

.dropdown-option:hover {
  background: #f5f5f5;
}

.dropdown-option.selected {
  background: #e6f7ff;
  color: #1890ff;
}

.dropdown-option input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.no-options {
  padding: 12px;
  text-align: center;
  color: #999;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 20px;
  }
  
  .modal-header, .modal-body, .modal-footer {
    padding: 16px;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .cancel-btn, .submit-btn {
    width: 100%;
  }
}
</style>
